module.exports = __webpack_public_path__ + "img/serifnew_box04.9bec6585.jpg";